<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<span class="int_type mgr_15">
					<select id="dlActive" v-model="active_yn" @change="search()">
						<option v-for="tag in this.$activeTags" v-bind:value="tag.value" v-bind:key="tag.value">{{ tag.text }}</option>
					</select>
				</span>

				<em class="lt_text">Department</em>
				<span class="int_type_no_border"> <CodeSelect :width="70" :descWidth="100" :codes="depts" v-model="dept_code" @set-code="setDepartment" /> </span>
				<!-- <em class="lt_text">{{ dept_name }}</em> -->

				<span class="int_type mgr_15">
					<input type="text" v-model="keyword" placeholder="Enter Search Keyword" autofocus autocomplete="off" @keyup.enter="search()" />
				</span>
				<a href="javascript:;" class="search_bt" @click="search()">Search</a>
				<a href="javascript:;" class="gray_bt" @click="reset()">Reset</a>
			</div>
		</div>
		<table class="list_tbl">
			<thead>
				<tr>
					<th width="7%">
						<a href="javascript:;" @click="sort('user_id')">User ID{{ sortMark('user_id') }}</a>
					</th>
					<th width="12%">
						<a href="javascript:;" @click="sort('name')">Name{{ sortMark('name') }}</a>
					</th>
					<th width="7%">
						<a href="javascript:;" @click="sort('user_type')">Type{{ sortMark('user_type') }}</a>
					</th>
					<th width="10%">
						<a href="javascript:;" @click="sort('department')">Department{{ sortMark('department') }}</a>
					</th>
					<th width="10%">
						<a href="javascript:;" @click="sort('sales_team')">Sales Team{{ sortMark('sales_team') }}</a>
					</th>
					<th width="10%">Phone No</th>
					<th width="5%">View Cost</th>
					<th width="5%">Price Adjust</th>
					<th width="5%">To M. P. Adj.</th>
					<th width="5%">To L. P. Adj.</th>
					<th width="50px;">GPS</th>
					<th width="50px;">ID Scan</th>
					<th>Default Menu</th>
					<th width="3%">Active</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="user in users" v-bind:key="user.user_id">
					<td class="al_left">
						<a href="javascript:;" @click="selectUser(user)">{{ user.user_id }}</a>
					</td>
					<td class="al_left">
						<a href="javascript:;" @click="selectUser(user)">{{ user.name }}</a>
					</td>
					<td class="al_left">{{ user.user_type | userTypeName }}</td>
					<td class="al_left">{{ user.dept_name }}</td>
					<td class="al_left">{{ user.sales_team_name }}</td>
					<td class="al_left">{{ user.phone_no }}</td>
					<td class="al_center">{{ user.cost_view_yn == 'Y' ? 'Y' : null }}</td>
					<td class="al_center">{{ user.price_adjust_yn == 'Y' ? 'Y' : null }}</td>
					<td class="al_center">{{ user.to_min_price_adjust_yn == 'Y' ? 'Y' : null }}</td>
					<td class="al_center">{{ user.to_lock_price_adjust_yn == 'Y' ? 'Y' : null }}</td>
					<td class="al_center">{{ user.gps_yn == 'Y' ? 'Y' : null }}</td>
					<td class="al_center">{{ user.login_id_scan ? 'Y' : null }}</td>
					<td class="al_left">{{ user.home_name }}</td>
					<td class="al_center">{{ user.active_yn }}</td>
				</tr>
			</tbody>
		</table>
		<div style="text-align:right;padding-right:10px;">Total Count : {{ list_count | commaSeparated }}</div>

		<Paging ref="paging" v-on:gotoPage="gotoPage"></Paging>

		<div class="bottom_bt_box">
			<ul>
				<li>
					<a v-if="sessionUser.super_admin_yn == 'Y'" href="javascript:;" @click="encryptPasswords()" style="margin-left:5px;">Encrypt Password Batch</a>
				</li>
				<li><router-link :to="{ name: 'userDetail', params: { mode: 'add' }, query: { backUri: this.uri } }">Add</router-link></li>
			</ul>
		</div>
	</div>
</template>

<script>
import { apiIndex, apiSelectUserList, apiEncryptPasswords } from '@/api/basicinfo/user.js';
import Paging from '@/components/common/Paging';
import CodeSelect from '@/components/common/CodeSelect';

export default {
	data: function() {
		return {
			uri: null,
			backUri: '/',
			paging_yn: 'Y',
			page_size: 25,
			page_no: 1,
			list_count: 0,

			sort_key: 'user_id',
			sort_direction: 'ASC',

			active_yn: 'Y',
			keyword: null,

			users: [],

			dept_code: '',
			//dept_name: '',
			depts: [],
		};
	},
	computed: {
		sessionUser: function() {
			return this.$session.get('user');
		},
	},
	components: {
		Paging,
		CodeSelect,
	},
	methods: {
		sortMark: function(sort_key) {
			if (this.sort_key == sort_key) return this.sort_direction == 'ASC' ? '▲' : '▼';
			else return null;
		},
		async encryptPasswords() {
			await apiEncryptPasswords();
			//const { data } = await apiEncryptPasswords();
			//console.log(data);
		},
		reset() {
			this.sort_key = 'user_id';
			this.sort_direction = 'ASC';
			this.keyword = null;
			this.dept_code = null;

			this.selectUsers();
			//this.active_yn = 'Y';
		},
		search() {
			this.selectUsers();
		},
		sort(sort_key) {
			if (this.sort_key == sort_key) {
				this.sort_direction = this.sort_direction == 'ASC' ? 'DESC' : 'ASC';
			} else {
				this.sort_key = sort_key;
				this.sort_direction = 'ASC';
			}
			this.selectUsers();
			//console.log(sort_key);
		},
		async selectUsers(pageNo) {
			console.log(pageNo);
			if (pageNo) this.page_no = pageNo;
			else this.page_no = 1;
			//console.log('select users');
			//const { data } = await selectAllPensioner();
			const { data } = await apiSelectUserList({
				dept_code: this.dept_code,
				keyword: this.keyword,

				paging_yn: this.paging_yn,
				page_size: this.page_size,
				page_no: this.page_no,
				start_index: this.page_size * (this.page_no - 1),
				sort_key: this.sort_key,
				sort_direction: this.sort_direction,

				active_yn: this.active_yn,
			});
			// this.pensioners = data;
			// if (this.pensioners.length > 0 && this.selectedPsNo == null) {
			// 	this.selectRow(this.pensioners[0]);
			// }
			//console.log(data);
			this.users = data.userList;
			this.list_count = data.list_count;

			this.$refs.paging.setPage(this.page_no, this.page_size, this.list_count);

			var uri = '/basic_info/user?active_yn=' + this.active_yn + '&page_no=' + this.page_no + '&sort_key=' + this.sort_key + '&sort_direction=' + this.sort_direction;
			if (this.keyword) uri += '&keyword=' + this.keyword;
			if (this.dept_code) uri += '&dept_code=' + this.dept_code;

			this.uri = uri;
			window.history.pushState({}, null, uri);
			/////this.$router.replace(uri).catch(err => err);
			//console.log(uri);
		},
		gotoPage(pageNo) {
			this.page_no = pageNo;
			this.selectUsers(pageNo);
		},
		selectUser(selected_user) {
			//console.log(user);
			//console.log(this.$route.fullPath);
			this.$router.push({ name: 'userDetail', params: { mode: 'detail' }, query: { backUri: this.uri, user_id: selected_user.user_id } });
		},
		//setDepartment(code) {
		setDepartment() {
			//console.log(code);
			//if (code) this.dept_name = code.name;
			//else this.dept_name = '';
			//this.selectUsers(this.page_no);
		},
		async index() {
			const { data } = await apiIndex();

			this.depts = data.deptList;
		},
		async init() {
			await this.index();

			if (this.$route.query.sort_key) this.sort_key = this.$route.query.sort_key;
			if (this.$route.query.sort_direction) this.sort_direction = this.$route.query.sort_direction;
			if (this.$route.query.active_yn) this.active_yn = this.$route.query.active_yn;

			if (this.$route.query.dept_code) this.dept_code = this.$route.query.dept_code;
			if (this.$route.query.keyword) this.keyword = this.$route.query.keyword;

			await this.selectUsers(this.$route.query.page_no);
		},
	},
	created() {
		//console.log(this.$route.query);
		//if (this.$route.query.page_no) this.page_no = this.$route.query.page_no;
		//if (this.$route.query.active_yn) this.active_yn = this.$route.query.active_yn;
		//if (this.$route.query.dept_code) this.dept_code = this.$route.query.dept_code;

		// if (this.$route.query.dept_code) {
		// 	console.log(this.$route.query.dept_code);
		// 	this.dept_code = this.$route.query.dept_code;
		// }
		//var vm = this;

		//this.$store.sideIndex = 9;
		this.$store.commit('setSideIndex', 9);
		//this.$store.selectedMenu = 'nav_li_25';
		this.$store.commit('setSelectedMenu', 'nav_li_user');
		this.$store.commit('setSubTitle', 'Basic Information -> Users');

		this.init();

		// this.index();
		// this.selectUsers(this.$route.query.page_no);

		// this.$nextTick(function() {
		// 	vm.dept_code = vm.$route.query.dept_code;
		// 	//this.dept_code = '3000';
		// 	//console.log(this.dept_code);
		// });

		//this.$toast.error('User page');
	},
	mounted() {
		// if (this.$route.query.dept_code) {
		// 	this.$nextTick(function() {
		// 		//this.dept_code = '9000';
		// 		this.dept_code = this.$route.query.dept_code;
		// 	});
		// }
		//console.log(this.$route.query.dept_code);
		//this.dept_code = this.$route.query.dept_code;
		//this.dept_code = '9000';
	},
};
</script>

<style></style>
